export const dashboardConstants = {
    DASHBOARD_REQUEST: 'DASHBOARD_REQUEST',
    DASHBOARD_GET_SUCCESS: 'DASHBOARD_GET_SUCCESS',
    DASHBOARD_FAILURE: 'DASHBOARD_FAILURE',  
}